import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconTextFormatSubheading(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fill="currentColor"
        d="M4 18a.967.967 0 0 1-.712-.288A.968.968 0 0 1 3 17V7c0-.283.096-.52.288-.713A.968.968 0 0 1 4 6c.283 0 .52.096.713.287.191.192.287.43.287.713v4h4V7c0-.283.096-.52.287-.713A.968.968 0 0 1 10 6c.283 0 .52.096.713.287.191.192.287.43.287.713v10c0 .283-.096.52-.287.712A.968.968 0 0 1 10 18a.967.967 0 0 1-.713-.288A.968.968 0 0 1 9 17v-4H5v4c0 .283-.096.52-.287.712A.967.967 0 0 1 4 18Zm10 0a.968.968 0 0 1-.713-.288A.968.968 0 0 1 13 17v-4c0-.55.196-1.02.588-1.412A1.926 1.926 0 0 1 15 11h4V8h-5a.968.968 0 0 1-.713-.287A.967.967 0 0 1 13 7c0-.283.096-.52.287-.713A.968.968 0 0 1 14 6h5c.55 0 1.02.196 1.413.588.391.391.587.862.587 1.412v3c0 .55-.196 1.02-.587 1.412A1.926 1.926 0 0 1 19 13h-4v3h5c.283 0 .52.096.712.288.192.191.288.429.288.712s-.096.52-.288.712A.968.968 0 0 1 20 18h-6Z"
      />
    </BaseIcon>
  );
}
